<input
  type="text"
  class="form-control form-control-lg"
  [value]="value" [placeholder]="placeholder || ''"
  
  (keyup)="onKeyup($event)"
  (blur)="onBlur()"
>
